<template>
    <div class="row">
        <FormGroup :label="$t('labels.user_name')" class="col-lg-6">
            <Input v-model="login"/>
        </FormGroup>
        <FormGroup :label="$t('labels.password')" class="col-lg-6">
            <Input v-model="password" type="password"/>
        </FormGroup>
        <FormGroup :label="$t('labels.domain')" class="col-lg-6">
            <Input v-model="domain" placeholder="https://example.com"/>
        </FormGroup>
    </div>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';

import { normalizeDomain } from './normalizeDomain';

export default {
    name: "LoginPasswordDomainCredentialFields",
    components: {
        FormGroup, Input
    },
    props: {
        credential: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            login: this.credential?.login ?? '',
            password: this.credential?.password ?? '',
            domain: this.credential?.domain ?? ''
        };
    },
    methods: {
        buildRequest() {
            let request = {
                login: this.login,
                password: this.password,
                domain: normalizeDomain(this.domain)
            };

            return request;
        }
    }
}
</script>
